import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';

import { Placeholders } from '../../assets/'
import { Fade, Grid, Grow, Zoom } from '@material-ui/core';
import ProductPrice from './ProductPrice';
import ProductStock from './ProductStock';
import { useHistory } from 'react-router';
import { PRODUCT_ACTIONS } from '../../redux/actions';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 255,
    backgroundSize: "cover"
  },
});

const ProductCard = (props) => {

  const dispatch = useDispatch()
  const setProduct = (product) => dispatch(PRODUCT_ACTIONS.setProduct(product))

  const classes = useStyles();

  const { id, name, slug, type, sku, price, regular_price, sale_price, total_sales, categories, images, loading, stock_status } = props

  const [anim, setanim] = useState(false)

  useEffect(() => {

    const anim = setTimeout(() => {
      setanim(true)
    }, 300)

    return () => {
      clearTimeout(anim)
    }
  }, [])

  const history = useHistory()
  const handleClick = () => {
    if(id){
      setProduct(props)
      history.push(`/products/${id}`)
    }
  }

  return (
    <Grow in={anim} >
      <Card className={classes.root} onClick={handleClick} >
        <CardActionArea>
          {loading ?
            <Skeleton variant="rect" width="100%" height={255} />
            :
            <CardMedia
              className={classes.media}
              image={images.length > 0 ? images[0].src : Placeholders.ph_default}
              title="Contemplative Reptile"
            />
          }
          <CardContent>
            <Typography variant="h6" gutterBottom noWrap >
              {loading ? <Skeleton /> : name.toUpperCase()}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              {loading ? <Skeleton /> : <ProductPrice {...props} />}
            </Typography>
            <Grid container >
              <Grid xs={4}>
                <Typography variant="subtitle2" gutterBottom>
                  {loading ? <Skeleton /> : `SKU:${sku}`}
                </Typography>
              </Grid>
              <Grid xs={4}>
                <Typography variant="subtitle2" gutterBottom>
                  {loading ? <Skeleton /> : `ID:${id}`}
                </Typography>
              </Grid>
              <Grid xs={4}>
                <Typography variant="subtitle2" gutterBottom>
                  {loading ? <Skeleton /> : <ProductStock {...props}/>}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </CardActionArea>
        {/* <CardActions>
          {loading ? <Skeleton variant="rect" width={80} /> : <Button variant="contained" size="small" color="primary">Share</Button>}
          {loading ? <Skeleton variant="rect" width={80} /> : <Button variant="contained" size="small" color="primary">Learn More</Button>}
        </CardActions> */}
      </Card>

    </Grow>
  );
}

ProductCard.propTypes = {

};

ProductCard.defaultProps = {
  id:null,
  images: [],
  loading: false
};

export default ProductCard